export { DSSeparator, DSSeparatorWithSchema, DSSeparator as default } from './DSSeparator.js';
import '@babel/runtime/helpers/esm/extends';
import '@babel/runtime/helpers/esm/defineProperty';
import 'react';
import 'react-desc';
import '@elliemae/ds-classnames';
//# sourceMappingURL=index.js.map
